<script>
import { mapGetters } from 'vuex'
import { postHotelRoomTypeStore } from '../api'
export default {
  data() {
    return {
      isLoadingStore: false,
      activeStep: 1,
      tabList: [
        {
          title: '基本資訊',
        },
        {
          title: '分類設定',
        },
        {
          title: '房價設定',
        },
        {
          title: '服務項目圖片',
        },
        {
          title: '房況管理',
        },
      ],
      stepDatas: {
        step1: {},
        step2: {},
        step3: {},
        step4: {},
        step5: {},
      },
      isVisibleSubmitPopup: false,
    }
  },
  components: {
    BaseSteps: () => import('@components/BaseSteps'),
    Step1: () => import('./Step1'),
    Step2: () => import('./Step2'),
    Step3: () => import('./Step3'),
    Step4: () => import('./Step4'),
    Step5: () => import('./Step5'),
  },
  computed: {
    ...mapGetters('hotel/setting', ['productId', 'productName']),
  },
  mounted() {
    if (!this.productId && !this.productName) {
      this.$confirm('請返回房型列表重新進入新增房型', '載入錯誤', {
        confirmButtonText: '確定',
        type: 'error',
        showCancelButton: false,
        showClose: false,
      }).then(() => {
        this.exit()
        this.$message({
          type: 'success',
          message: '已返回房型列表頁面',
        })
      })
    }
  },
  methods: {
    async submitData() {
      this.stepDatas.step5 = this.$refs.step5.getStepData()

      const { step1, step3, step4, step5 } = this.stepDatas
      const payload = {
        ...step1,
        productId: this.productId,
        features: step1.features,
        prices: step3,
        images: [{ path: step4 }],
        state: step5.state,
        startDate: step5.startDate,
        endDate: step5.endDate,
        closedDates: step5.closedDates,
      }
      try {
        this.isVisibleSubmitPopup = true
        await this.fetchStore(payload)
      } catch (error) {
        console.log(error)
      } finally {
        this.isVisibleSubmitPopup = false
      }
    },
    async fetchStore(data) {
      try {
        this.isLoadingStore = true
        this.$message.info('儲存中，請稍候...')
        await postHotelRoomTypeStore(data)
      } catch (error) {
        console.log(error)
        this.$message.error('儲存失敗，請稍後再試')
      } finally {
        this.isLoadingStore = false
        this.$router.push('/hotel?tab1=1')
        this.$message.success('新增房型成功')
      }
    },
    goBack() {
      this.activeStep--
    },
    async goNext() {
      const isValid = await this.$refs[`step${this.activeStep}`].validateForm()
      if (!isValid) {
        return
      }
      this.stepDatas[`step${this.activeStep}`] = this.$refs[`step${this.activeStep}`].getStepData()
      this.activeStep++
    },
    exit() {
      this.$router.push('/hotel?tab1=1')
    },
  },
}
</script>

<template>
  <div>
    <BaseSteps :active="activeStep" :list="tabList" />
    <div class="content">
      <h3>
        當前設定分店：
        <span style="color:#EA6A29">{{ productName }} </span>
      </h3>
      <keep-alive>
        <Step1 v-if="activeStep === 1" ref="step1" />
        <Step2 v-else-if="activeStep === 2" ref="step2" />
        <Step3 v-else-if="activeStep === 3" ref="step3" :chosenCategories="stepDatas.step2" />
        <Step4 v-else-if="activeStep === 4" ref="step4" />
        <Step5 v-else-if="activeStep === 5" ref="step5" />
      </keep-alive>
    </div>
    <div class="footer">
      <el-button class="is-round" @click="exit">離開</el-button>
      <el-button v-if="activeStep !== 1" class="is-round" @click="goBack">上一步</el-button>
      <el-button v-if="activeStep < tabList.length" class="is-round" type="primary" @click="goNext()">
        下一步
      </el-button>
      <el-popover v-if="activeStep === 5" placement="top" width="300" v-model="isVisibleSubmitPopup">
        <p>確認是否建立並新增此房型資料？</p>
        <div style="text-align: right; margin: 0">
          <el-button class="is-round" @click="isVisibleSubmitPopup = false">
            取消
          </el-button>
          <el-button class="is-round" type="primary" @click="submitData()">
            確定
          </el-button>
        </div>
        <el-button slot="reference" class="is-round" type="primary" :loading="isLoadingStore" :disabled="isLoadingStore" style="width: 100%;margin-left:10px">
          完成
        </el-button>
      </el-popover>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.content {
  padding: 18px 20px 20px;
  background-color: #fff;
}

.footer {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: $size-sidebar-width;
  z-index: $layer-page-footer-z-index;
  width: calc(100% - #{$size-sidebar-width});
  padding: 20px 0;
  padding-left: 5%;
  padding-right: 5%;
  text-align: center;
  background-color: white;

  > * {
    flex: 1 0 0;
  }
}
</style>
